<template>
  <div>
    <div class="project-list m-t-md">
        <table class="table table-hover m-t-sm">
            <sorted-headers :headers="headers" @triggerSort="taskStore.setSortOrder($event.prop, $event.dir)"></sorted-headers>
            <tbody>
              <tr v-for="task in tasks" :key="task.id">
                <td>
                  <span><strong>
                    <router-link :to="{path: `/task-manager/tasks/${task.slug && !task.slug.includes('undefined')  ?  task.slug : task.id}`}">
                      {{ task.title }}
                    </router-link>
                    </strong></span>
                    <small><b>{{ task.slug ? '#' + task.slug : ''}}</b></small>
                </td>
                <td>
                  <span v-if="task.project">
                    <router-link v-if="!task.project.archived" :to="{path: `/task-manager/projects/${task.project.id}`}">
                      {{ task.project.name  }}
                    </router-link>
                    <span v-else>
                      <i class="fa fa-exclamation-triangle m-l-sm red" v-tooltip="'This project has been deleted'"></i>
                      {{ task.project.name }}
                    </span>
                  </span>
                  <span v-else> / </span>
                </td>
                <td><span class="label label-primary" v-if="task.departments[0]">{{ task.departments[0] }}</span></td>
                <td><span class="label label">{{ task.priority || '/' }}</span></td>
                <td><span class="label label-primary">{{ task.status || '/' }}</span></td>
                <td>
                  <span class="label label-success">{{task.creator ? task.creator.name : '/' }}</span>
                </td>
                <td>
                  <span class="label label-success">{{task.assignee ? task.assignee.username : '/' }}</span>
                </td>
                <td>
                  {{ task.dueDate | aTime() }}
                </td>
                <td>
                  {{ task.created | aTime('DD.MM.YY') }}
                </td>
              </tr>
            </tbody>
        </table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Browser } from '../../../../mixins/helperMixin'
import SortByHeaders from './SortByHeaders.vue'
import { useTaskStore } from '../../../../stores/TaskStore'
import { storeToRefs } from 'pinia'

export default {
  setup () {
    const taskStore = useTaskStore()
    const { tasks } = storeToRefs(taskStore)
    return { taskStore, tasks }
  },
  data () {
    return {
      headers: [
        {
          label: 'Title',
          index: 'title'
        },
        {
          label: 'Project',
          index: 'project'
        },
        {
          label: 'Department',
          index: 'department'
        },
        {
          label: 'Priority',
          index: 'priority'
        },
        {
          label: 'Status',
          index: 'status'
        },
        {
          label: 'Created By',
          index: 'creator'
        },
        {
          label: 'Assigned To',
          index: 'assignee'
        },
        {
          label: 'Deadline',
          index: 'dueDate'
        },
        {
          label: 'Created',
          index: 'created'
        }
      ]
    }
  },
  mixins: [Browser],
  components: {
    sortedHeaders: SortByHeaders
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      dataLists: 'getData'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/TaskManager/Tasks/List.vue